import autosaveService from './common/services/AutosaveService'
import FormService from './common/services/FormService';
import _ from 'lodash';

const formService = new FormService();

let previousForm = null;
let previousEvent = null;

let save = async (event, showSave: Boolean) => {
    if (showSave) {
        autosaveService.activateAnimation();
    }
    if (event.target.type !== 'file') {
        let promise = formService.save($(event.currentTarget));
        let response;
        if (showSave) {
            response = await autosaveService.saving(promise);
        } else {
            response = await promise;
        }
        if ($(event.currentTarget).hasClass("process-payment") && response.success){
            if ($(event.currentTarget).hasClass("edit-payment")){
                let checkNumVal = $(event.currentTarget).find("input.check-number").val();
                //@ts-ignore
                $(event.currentTarget).find(".check-number-show").text(checkNumVal);
                $(event.currentTarget).find("article.paid-payment")
                    .find('.show-payment, .edit-payment')
                    .toggleClass('hide');
                $(event.currentTarget).find("article.paid-payment").find('.spinner-container').addClass("hide");
                $(event.currentTarget).find("article.paid-payment").find('.submit-payment').addClass('hide');
            }
            else{
                let oldRecordNum = parseInt($(document).find(".record-count").text());
                $(document).find(".record-count").text(oldRecordNum-1);
                $(event.currentTarget).slideUp( 300  )
            }
        }

        console.log(response);
    }
};

let saveDebounced = _.debounce(async e => {
    await save(e, true);
    previousForm = null;
    previousEvent = null;
}, window.AppConfig.saveTimeout());

//propertychange is for internet explorer support
$(document).on('propertychange input change date-change', '.autosave_form', async e => {
    //fix for IE -- any utf8 characters in the dom will fire change event on page load for each input with the character
    if ((<any>e.target).name == "utf8") { return; }
    if (previousForm != null && previousForm != e.currentTarget) {
        await save(previousEvent, false);
    }
    previousForm = e.currentTarget;
    previousEvent = e;
    saveDebounced(e);
});


$(document).on('asyncFormSubmit', '.process-payment', async e => {
    //fix for IE -- any utf8 characters in the dom will fire change event on page load for each input with the character
    if ((<any>e.target).name == "utf8") { return; }
    if (previousForm != null && previousForm != e.currentTarget) {
        await save(previousEvent, false);
    }
    previousForm = e.currentTarget;
    previousEvent = e;
    saveDebounced(e);
});





// $(document).on('click', '.validate-schedule', async (e) => {
//    if ( previousForm != null ) {
//        saveDebounced.cancel();
//        await save(previousEvent, true);
//        previousForm = null;
//        previousEvent = null;
//        $(e.target).click();
//    }
// });
$(document).on('turbo:before-visit', (event) => {
    if ( previousForm != null ) {
        let url = (<any>event).originalEvent.detail.url;
        event.preventDefault();
        saveDebounced.cancel();
        save(previousEvent, false)
            .then(() => {
                console.log('done');
                previousForm = null;
                previousEvent = null;
                window.Turbo.visit(url);
            });
    }
});